var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box_wrap",staticClass:"box_wrap"},[_c('div',{staticClass:"box_rorate bg1"}),_c('div',{staticClass:"box_rorate bg2"}),_c('div',{staticClass:"slot-wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }